import api from '../../utils/api'

import { useEffect, useState } from 'react'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormProvider from './form/FormProvider'

function EditProvider({id , btCancelAction, handleOnSuccess}){
    const [provider, setProvider] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const {setFlashMessage} = useFlashMessage()

    useEffect(() => {

        api.get(`/provider/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {

            setProvider(response.data.provider)
        })
    }, [token, id])

    async function updateProvider(provider) {
        let msgType = 'success'


        const data = await api.patch(`provider/${provider._id}`, provider, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            }

    }


    return (
        provider.name && (
            <FormProvider title="Editar Fornecedor" handleSubmit={updateProvider} btnText="Salvar" btCancelAction={btCancelAction} providerData={provider} />
        )
    )
}

export default EditProvider
